import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {finalize} from 'rxjs/operators';
import {PrintMenuService} from "../../../../core/services/gestionmenus/print-menu.service";
import {
  PreparationConditionnementService
} from "../../../../core/services/conditionnements/preparation-conditionnement.service";
import {BonAllotGroupingOrder} from "../../../../core/enums/bon-allotissement-grouping-enum";
import {BonAllotissementSortingEnum} from "../../../../core/enums/bon-allotissement-sorting-enum";
import BonAllotissementSettingsMl from "../../../../core/dtos/conditionnement/bon-allotissement-settings-ml";
import {ButtonThemeEnum} from '../../../../shared/ui/button/button-theme-enum';

@Component({
    selector: 'yo-bon-allotissement',
    templateUrl: './bon-allotissement.component.html',
    styleUrls: ['./bon-allotissement.component.scss'],
    standalone: false
})

export class BonAllotissementComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;


  @Input() public idPlanProduction: number;
  @Input() public idPlanProductionDetails: number[];
  @Output() loadingChange = new EventEmitter<{ visible: boolean; message: string }>();
  displayDialog: boolean = false;
  defaultOrder: boolean = true;
  dontDisplayMeal: boolean = false;
  sorting: BonAllotissementSortingEnum = BonAllotissementSortingEnum.DATE_LIVRAISON;
  formatPrintingOptions: any[] = [{ label: 'Tournée / Plat / Plc', value: this.defaultOrder }, { label: 'Plat / Tournée / Plc', value: !this.defaultOrder }];
  sortPrintingOptions: any[] = [{ label: 'Date de livraison', value: BonAllotissementSortingEnum.DATE_LIVRAISON }, { label: 'Date de fabrication', value: BonAllotissementSortingEnum.DATE_FABRICATION }];

  totalAndTraca: boolean = false;

  constructor(
    private printMenuService: PrintMenuService,
    private pcSvc: PreparationConditionnementService) {
  }

  ngOnInit(): void {
    this.printMenuService.displayDialogPrintBonAllotissement$.subscribe(() => {
      this.displayDialog = true;
      this.defaultOrder = true;
      this.totalAndTraca = false;
    });
  }

  ngOnDestroy(): void {
    this.displayDialog = false;
  }

  downloadBonAllotissement = (): void => {
    const grouping: BonAllotGroupingOrder = this.defaultOrder ? BonAllotGroupingOrder.TOURNEE_PLAT_PLC : BonAllotGroupingOrder.PLAT_TOURNEE_PLC;
    const settings: BonAllotissementSettingsMl = new BonAllotissementSettingsMl();
    settings.idPlanProduction = this.idPlanProduction;
    settings.grouping = grouping;
    settings.force = false;
    settings.totalTraca = this.totalAndTraca;
    settings.sortingDate = this.sorting;
    settings.planProductionDetailsList = this.idPlanProductionDetails;
    settings.displayMeal = !this.dontDisplayMeal;
    this.displayDialog = false;
    this.loadingChange.emit({ visible: true, message: 'Impression en cours...' });
    this.pcSvc.printBonAllotissement(settings)
      .pipe(finalize(() => this.loadingChange.emit({ visible: false, message: '' })))
      .subscribe();
  };

  closeDialog = () => {
    this.displayDialog = false;
    this.defaultOrder = true;
    this.sorting = BonAllotissementSortingEnum.DATE_LIVRAISON;
  }
}
